import type { ILocalization } from '../interfaces/localizations';

export function convertLocalizationsToMap(localizations: ILocalization[] | undefined | null): Map<string, string> {
  const localizationsMap: Map<string, string> = new Map<string, string>();
  if (localizations == null) {
    return localizationsMap;
  }
  localizations.map((localization) => {
    return localizationsMap.set(localization.key, localization.value);
  });
  return localizationsMap;
}

export function getLocalizedMessage(key: string, localizations: Map<string, string>): string {
  return localizations.get(key) ?? '';
}
